import { getCloudMarketplaceAppByKey, makeAppKey } from '@atlassian/mpac-api-client';
import { Either } from 'funfix-core';
import { toSPIInstallableAddonIdentifier } from '../../records/InstallableAppIdentifier';
import getSPI from '../../services/SPI';
import { reflect } from '../../utils/promise-utils';
const getAppPermission = ia => getSPI().hasInstallPermission({
  addon: ia
}).then(pc => ({
  installableAddon: ia,
  installPermission: Either.right(pc)
})).catch(error => ({
  installableAddon: ia,
  installPermission: Either.left(error)
}));
export const retrieveAppDataByKey = function retrieveAppDataByKey(_ref) {
  let {
    installableAppByKeyId,
    mpacBaseUrl
  } = _ref;
  let hostCmtEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return Promise.all([reflect(getSPI().getInstallableAddon({
    addon: toSPIInstallableAddonIdentifier(installableAppByKeyId),
    hostCmtEnabled
  }).then(getAppPermission)), getCloudMarketplaceAppByKey(mpacBaseUrl, installableAppByKeyId.key)]).then(_ref2 => {
    let [appPermission, marketplaceApp] = _ref2;
    return {
      installableAddon: appPermission.map(a => a.installableAddon),
      installPermission: appPermission.flatMap(a => a.installPermission),
      marketplaceApp
    };
  });
};
export const retrieveAppDataByUrl = _ref3 => {
  let {
    installableAppByUrlId,
    mpacBaseUrl
  } = _ref3;
  return (
    // Only succeed in install-by-URL case if the SPI request succeeds
    getSPI().getInstallableAddon({
      addon: toSPIInstallableAddonIdentifier(installableAppByUrlId)
    }).then(installableAddon => Promise.all([getCloudMarketplaceAppByKey(mpacBaseUrl, makeAppKey(installableAddon.details.key)), reflect(getAppPermission(installableAddon))]).then(_ref4 => {
      let [marketplaceApp, appPermission] = _ref4;
      return {
        installableAddon: Either.right(installableAddon),
        installPermission: appPermission.flatMap(a => a.installPermission),
        marketplaceApp
      };
    }))
  );
};
export const retrieveAppDataByAri = _ref5 => {
  let {
    installableAppByARI,
    mpacBaseUrl
  } = _ref5;
  return Promise.all([reflect(getSPI().getInstallableAddon({
    addon: toSPIInstallableAddonIdentifier(installableAppByARI)
  }).then(getAppPermission)), getCloudMarketplaceAppByKey(mpacBaseUrl, installableAppByARI.appKey)]).then(_ref6 => {
    let [appPermission, marketplaceApp] = _ref6;
    return {
      installableAddon: appPermission.map(a => a.installableAddon),
      installPermission: appPermission.flatMap(a => a.installPermission),
      marketplaceApp
    };
  });
};